import VTooltipDefault, { VTooltip } from 'v-tooltip';
import Vue, { VNode } from 'vue';

Vue.use(VTooltipDefault, { disposeTimeout: 200 });

/**
 * Default options
 */
const options = {
	placement: 'right-start',
	offset: 10,
	delay: {
		show: 500,
		hide: 0,
	},
	classes: ['olb-tooltip-wrapper'],
	template: '<div class="tooltip" role="tooltip"><div class="olb-tooltip-inner"></div></div>',
	innerSelector: '.olb-tooltip-inner',
};
/**
 * Bind delegate
 */
function bind(
	el: HTMLElement,
	{
		name,
		value,
		oldValue,
		arg,
		modifiers,
	}: {
		name: string;
		value?: string | object;
		oldValue?: string | object;
		arg?: string;
		modifiers: { [key: string]: boolean };
	},
	vnode: VNode,
	oldVnode: VNode,
): void {
	const mergedValue = {
		...options,
		...(typeof value === 'object' ? { ...value } : { content: value }),
		...(arg && { placement: arg }),
	};
	VTooltip.bind && VTooltip.bind(el, { name, value: mergedValue, oldValue, modifiers }, vnode, oldVnode);
}

/**
 * Simple tooltip directive to display text, using  the package v-tooltip (https://github.com/Akryum/v-tooltip).
 */
const OlbTooltip = {
	...VTooltip,
	bind,
	update: bind,
};

export default Vue.directive('tooltip', OlbTooltip);
